import { render } from "./RedOutLineBox.vue?vue&type=template&id=22824b1e&scoped=true"
const script = {}

import "./RedOutLineBox.vue?vue&type=style&index=0&id=22824b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22824b1e"]])

export default __exports__